<!-- @format -->

<ng-container *transloco="let t">
  @if (currentPlan.primary) {
    <sis-tiny-badge variant="success" [id]="primaryBadgeId">{{ t("PRIMARY_STUDY_PLAN") }}</sis-tiny-badge>
  }
  <sis-description-list-compact [columnCount]="1" [ariaDescribedBy]="currentPlan.primary ? primaryBadgeId : null">
    <dl>
      <ng-template #compactListItem>
        <dt class="label colon">{{ t("ENTITY_NAMES.education") }}</dt>
        @if (currentPlan.rootId | education | async; as education) {
          <dd class="value">
            {{
              t("STUDY_PLAN_EDUCATION_INFO", {
                educationName: education.name | localizedString,
                learningOpportunityName: currentPlan.learningOpportunityId | learningOpportunityName: education | localizedString,
                curriculumPeriodName: currentPlan.curriculumPeriodId | curriculumPeriodName | async,
              })
            }}
          </dd>
        }
      </ng-template>

      <ng-template #compactListItem>
        <dt class="label colon">{{ t("FIELD_NAMES.created") }}</dt>
        <dd class="value">
          {{ currentPlan.metadata.createdOn | localDateFormat }}
        </dd>
      </ng-template>

      <ng-template #compactListItem>
        <dt class="label colon">{{ t("FIELD_NAMES.modified") }}</dt>
        <dd class="value">
          {{ currentPlan.metadata.lastModifiedOn | localDateFormat }}
        </dd>
      </ng-template>
    </dl>
  </sis-description-list-compact>
</ng-container>
